<template>
  <!-- 百度地图位置 -->
  <div class="canvas-wrap">
    <div :id="mapId" ref="map_canvas" style="width: 100%; height: 100%"></div>
    <div class="uyu-zoomControl">
      <div @click="setMapZoom()">
        <div class="el-icon-refresh-left"></div>
      </div>
      <div @click="map.zoomIn()">
        <div class="el-icon-zoom-in"></div>
      </div>
      <div @click="map.zoomOut()">
        <div class="el-icon-zoom-out"></div>
      </div>
      <div v-if="!isPop" @click="centerDialogVisible = true">
        <div class="el-icon-full-screen"></div>
      </div>
    </div>
    <!-- 地图全屏 -->
    <el-dialog
      v-if="centerDialogVisible"
      title="公司地图"
      :visible.sync="centerDialogVisible"
      width="30%"
      center
      fullscreen
    >
      <BaiduCustomeMap :mapId="'map_popup'" :isPop="true" />
    </el-dialog>
  </div>
</template>
<script>
import { loadBMap } from "@/utils/baidu-map/loadResources";
import http from "../../../axios/index";
import * as cookieServ from "@/utils/methods/cookie";
const styleJson = require("@/utils/baidu-map/custom_map_config.json");
export default {
  name: "BaiduCustomeMap",
  props: {
    mapId: {
      type: String,
      default: () => {
        return "map_canvas";
      },
    },
    isPop: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  data() {
    return {
      map: null, // 百度地图引用
      myGeo: null,
      mapZoom: 7, // 地图级别
      mapCenter: {
        // 地图中心(湛江)
        lng: 110.365494,
        lat: 21.277163,
      },
      orgInfo: {
        address: "",
      },
      markers: [],
      centerDialogVisible: false,
    };
  },
  computed: {},
  methods: {
    // 初始化图表
    mapHandle() {
      const mainAddress = this.$store.state.app.rootOrganAddress;
      const mainName = localStorage.getItem("rootOrgName");
      console.log(mainName, mainAddress);
      const _this = this;
      console.log(this.markers);
      // 主方法 **
      var map = new BMapGL.Map(this.mapId);
      this.map = map;
      // map.setMapStyleV2({
      //   styleId: 'b93ef249fb1efad69f3947d2f695e53a',
      // })
      // map.setMapStyleV2({ styleJson: styleJson });

      //创建地址解析器实例
      this.myGeo = new BMapGL.Geocoder();
      // 获取总公司的经纬
      // 将地址解析结果显示在地图上，并调整地图视野
      mainAddress &&
        this.myGeo.getPoint(
          mainAddress,
          function (point) {
            if (point) {
              _this.map.centerAndZoom(
                new BMapGL.Point(point.lng, point.lat),
                _this.mapZoom
              );
              (_this.mapCenter.lng = point.lng),
                (_this.mapCenter.lat = point.lat);
              // 创建添加点标记
              var marker = new BMapGL.Marker(
                new BMapGL.Point(point.lng, point.lat)
                // { title: mainName }
              );
              _this.map.addOverlay(marker);
              marker.setLabel(
                new BMapGL.Label(mainName, {
                  offset: new BMapGL.Size(10, -10),
                })
              );
            }
          },
          ""
        );

      // 初始化地图,设置中心点坐标和地图级别
      !mainAddress &&
        _this.map.centerAndZoom(
          new BMapGL.Point(this.mapCenter.lng, this.mapCenter.lat),
          this.mapZoom
        );
      // map.setCurrentCity("湛江"); // 设置地图显示的城市 此项是必须设置的
      _this.map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
      _this.map.setMapType(BMAP_NORMAL_MAP); // 设置地图类型为地球模式：BMAP_EARTH_MAP; BMAP_NORMAL_MAP 正常模式
      _this.map.addEventListener("click", function (e) {
        // 监听整张地图的鼠标点击事件
        console.log("点击位置经纬度：" + e.latlng.lng + "," + e.latlng.lat);
      });
      // var scaleCtrl = new BMapGL.ScaleControl(); // 添加比例尺控件
      // map.addControl(scaleCtrl);

      this.setMarkers();
    },
    setMapZoom() {
      // 返回默认中心及级别
      this.map.centerAndZoom(
        new BMapGL.Point(this.mapCenter.lng, this.mapCenter.lat),
        this.mapZoom
      );
    },

    jump(orgId, orgName) {
      console.log(orgId, orgName);
      localStorage.setItem("orgId", orgId);
      localStorage.setItem("orgName", orgName);
      let hostname = window.location.hostname;
      let protocol = window.location.protocol;
      let url = "";
      // let domain = "";
      if (hostname == "localhost") {
        // 本地开发
        url = "http://localhost:8083/uyu-desktop/day/ym?flag=1";
        // domain = "localhost";
      } else if (hostname == "desktop-test.uyu1027.com") {
        // 预上线测试
        url =
          (protocol ? protocol : "http:") +
          "//desktop-test.uyu1027.com/uyu-desktop/day/ym?flag=1";
        // domain = ".uyu1027.com";
      } else if (hostname == "desktop.uyu1027.com") {
        // 正式
        url =
          (protocol ? protocol : "https:") +
          "//desktop.uyu1027.com/uyu-desktop/day/ym?flag=1";
        // domain = ".uyu1027.com";
      }
      // document.cookie =
      //   "token=" + data.data.token + ";domain=" + domain + ";path=/";
      window.open(url);
    },
    // 设置地址标识
    setMarkers() {
      const _this = this;
      const markers = [];
      const organs = this.$store.state.app.organList;
      for (let i = 0; i < organs.length; i++) {
        const item = organs[i];
        // 获取公司经纬
        item.address &&
          markers.push({
            id: item.id,
            name: item.orgName,
            address: item.address,
          });
      }
      this.markers = markers;
      this.markers.forEach((item) => {
        // 将地址解析结果显示在地图上，并调整地图视野
        this.myGeo.getPoint(
          item.address,
          function (point) {
            if (point) {
              console.log(item.name, point);
              // 创建添加点标记
              var marker = new BMapGL.Marker(
                new BMapGL.Point(point.lng, point.lat)
                // { title: item.name }
              );

              console.log("marker", marker);
              _this.map.addOverlay(marker);
              if (item.name.includes("草潭")) {
                marker.setLabel(
                  new BMapGL.Label(item.name, {
                    offset: new BMapGL.Size(-120, -10),
                  })
                );
              } else {
                marker.setLabel(
                  new BMapGL.Label(item.name, {
                    offset: new BMapGL.Size(10, -10),
                  })
                );
              }
              // marker添加点击事件
              marker.addEventListener("click", function (e) {
                console.log("点击", item.id, item.name);
                _this.jump(item.id, item.name);
              });
            } else {
              console.log("定位失败", item.name);
            }
          },
          "广东省"
        );
      });
    },
    // 加载详情数据
    loadAreaInfo() {},
  },
  components: {},
  beforeMount() {
    // 模板编译/挂载之前
    this.loadAreaInfo();
  },
  mounted() {
    // 模板编译/挂载之后
  },
  created() {
    window.initBaiduMapScript = () => {
      this.mapHandle();
    };
    loadBMap("initBaiduMapScript");
  },
  beforeUpdate() {
    // 组件更新之前
  },
  updated() {
    // 组件更新之后
  },
  beforeDestroy() {
    // 组件销毁前调用
    // Tips：你确认删除XX吗？
  },
  destroyed() {
    // 组件销毁后调用
    // Tips：当前组件已被删除，清空相关内容
    this.map = null;
  },
  // 数据监听
  watch: {
    // keyName: {
    // 注意：当观察的数据为对象或数组时，curVal和oldVal是相等的，因为这两个形参指向的是同一个数据对象
    // deep: true,
    //handler (curVal, oldVal) {
    // console.log(curVal, oldVal)
    //}
    // }
    "$store.state.app.organList": {
      deep: true,
      handler(val) {
        if (val) {
          this.setMarkers();
        }
      },
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../../assets/less/baidu-map.less";
.canvas-wrap {
  width: 100%;
  height: 100%;
  position: relative;
  .map_canvas {
    width: 100% !important;
    height: 100% !important;
  }
  .uyu-zoomControl {
    box-shadow: rgb(107 120 137 / 20%) 0px 2px 6px 0px,
      rgb(91 98 107 / 8%) 0px 4px 10px 0px;
    background: rgb(255, 255, 255);
    position: absolute;
    z-index: 9;
    inset: auto 15px 20px auto;
    width: 26px;
    > div {
      box-shadow: 1px 2px 1px rgb(147 142 142);
      cursor: pointer;
      width: 26px;
      height: 26px;
      left: 30px;
      overflow: hidden;
      background-color: #fff;
      z-index: 10;
      &:not(:last-child) {
        border-bottom: 1px solid #ccc;
      }
      > div {
        font-size: 16px;
        color: #999999;
        margin-top: 5px;
        margin-left: 5px;
        font-weight: 400;

        &:hover {
          color: #3385ff;
        }
      }
    }
  }
  /deep/.el-dialog__header {
    border: 1px solid #2f333b;
    background: #232231;
    box-sizing: border-box;
    .el-dialog__title {
      color: #fff;
    }
    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 20px;
    }
  }
  /deep/.el-dialog__body {
    width: 100%;
    height: calc(100% - 56px);
    padding: 0;
  }
}
/deep/.anchorBL {
  display: none;
}
/deep/.BMapLabel {
  border: 1px solid rgb(157 39 242) !important;
  padding-left: 5px !important;
  padding-right: 5px !important;
}
</style>
